import React from 'react';
import PropTypes from 'prop-types';

import { FormatInteger } from 'utils/format';
import { DetailCell } from './styled';

const t = {
  kg: 'Kg',
};

const VehicleMaxWeight = ({ max_weight, className, ...props }) => (
  <DetailCell className={className} {...props}>
    {max_weight && max_weight > 0 ? (
      <span>
        <FormatInteger value={max_weight} />
        &nbsp;
        {t.kg}
      </span>
    ) : null}
  </DetailCell>
);

VehicleMaxWeight.propTypes = {
  max_weight: PropTypes.string,
  className: PropTypes.string,
};

export default VehicleMaxWeight;
